import { render } from "./LanguageSelect.vue?vue&type=template&id=92aaf85c&scoped=true"
import script from "./LanguageSelect.vue?vue&type=script&lang=js"
export * from "./LanguageSelect.vue?vue&type=script&lang=js"

import "./LanguageSelect.vue?vue&type=style&index=0&id=92aaf85c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92aaf85c"]])

export default __exports__